import React from 'react'
import AdminRestaurants from './Restaurants'

export default function Admin() {
  return (
    <div>
      <h1>Painel Admin</h1>
      <AdminRestaurants />
    </div>
  )
}
